/* global pendo */
import { useEffect, useState, createContext } from "react";
import { Toaster } from "react-hot-toast";
import { Outlet, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "./AppRoot.css";
import { selectUser } from "../../../redux/features/appData";
import { AppHeader } from "../app-header/AppHeader";
import { WazToolbar } from "../../wazawan/toolbar/WazToolbar";
import { AppSidebar } from "../sidebar/AppSidebar";

type AppRootProps = {

};
export const AppRoot = ({}: AppRootProps) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const storeUser = useSelector(selectUser);

  if (storeUser) {
    document.body.className = storeUser.theme;
  }

  console.log("[AppRoot/main] storeUser: ", storeUser);

  return (
        <>
            <div id="app-root">
                <WazToolbar viewingApp={true}/>
                <AppSidebar />
                
                <div className="app-contents">
                    <AppHeader />
                    <div className="app-body">
                        <Outlet context={[]} />
                    </div>
                </div>
                
            </div>

            <Toaster />
        </>
  );
}
